import React from "react";
import { HomeCategoriesUI } from "./HomeCategoriesUI";
import { useFetchGet } from "../../../hooks";


function HomeCategories() {
    const { data, isLoading, hasError } = useFetchGet('https://app-nuokwylgla-uc.a.run.app/api/v1/categories');
    
    console.log('HomeCategories - isLoading:', isLoading);
    console.log('HomeCategories - data:', data);
    console.log('HomeCategories - hasError:', hasError);
    
    if (!isLoading) {
        if (data) {
            return (
                <HomeCategoriesUI
                    data={data}
                />
            );
        } else {
            return <div style={{ padding: '40px', textAlign: 'center', color: '#d7b547' }}>No hay categorías disponibles</div>;
        }
    }
    
    return <div style={{ padding: '40px', textAlign: 'center', color: '#d7b547' }}>Cargando categorías...</div>;
}

export { HomeCategories }